import { Index } from '@modules/missions/keaz/group'

export function KeazGroup() {
  return <Index />
}
